import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    ar: {
        dashboard: 'لوحة المعلومات',
        mortgages: {
            title: ' الرهون',
            mortgage: {
                MortgagesNo: 'رقم الرهن',
                creationTime: 'تاريخ الإصدار',
                theType: 'النوع',
                commercialNumber: 'رقم السجل التجاري',
                birthDate: 'تاريخ الميلاد',
                name: 'الأسم',
                nationality: 'الجنسية',
                hawyaType: 'نوع الهوية',
                hawyaNumber: 'رقم الهوية',
                number: 'رقم',
                iqama: 'إقامة',
                hawya: 'الهوية ',
                iqamaOrHawya: 'رقم الهوية / الإقامة',
                validUntil: 'تاريخ انتهاء ',
                invalidInput: 'رقم الهوية / الإقامة غير صحيحة',
                person: 'فرد',
                company: 'شركة',
                hejri: 'هجري',
                melady: 'ميلادي',
                approveTitle: ' شاشة التحقق',
                rejectTitle: 'اسباب الغاء الرهن',
                EnterOTP: 'الرجاء إدخال رمز التحقق المرسل إلى جوالك',
                time: ' {0} دقائق و {1} ثانية ',
                expireTime: 'الوقت المتبقي لانتهاء مدة رمز التحقق',
                expireTimeEnded: '.. عذراً ، انتهى وقت رمز التحقق'

            },
            index: {
                newRequest: 'طلب جديد',
                doneRequestSent: 'تم إرسال الطلب إلى الكفيل',
                requests: 'الطلبات',
                list: 'قائمة الإقرارات',
                SendRequest: 'ارسال الطلب',
                choose: 'اختر',
                filter: 'تصفية النتائج'

            },
            msg: {
                acceptIqrar: 'قبول او رفض الأقرار بكفالة',
                cancelIqrarRequsr: 'إرسال طلب إنهاء الإقرار ',
                cancelIqrarDecision: 'الموافقة او الرفض على طلب إنهاءالإقرار',
                cancelIqrar: 'إنهاء الإقرار',
                dateEntry: 'اختيار التاريخ الزامي',
                unknownError: 'هناك خطأ',
                sorry: 'نعتذر !',
                notCompleteData: 'البيانات غير مكتملة ',
                errorOnRegister: 'خطأ اثناء التسجيل ',
                errorsNationalId: 'رقم الهوية / الإقامة غير صحيحة',
                errorsDateRequire: '  اختيار التاريخ الزامي',
                errorsReasonFieldRequire: 'خانة سبب الكفالة ضرورية',
                errorsFieldRequire: 'خانة "{0}" ضرورية',
                errorsDateFieldRequire: 'خانة "{0}" به التاريخ غير صحيح',

            },
            view: {
                partyDetails: 'بيانات الأطراف',
                iqrarKafalaDetails: 'بيانات إقرار الكفالة',
                completeKafala: 'إنهاء الإقرار',
                canApproveRejectCompleteKafalaRequest: 'الموافقة او الرفض على طلب إنهاءالإقرار',
                canSendCompleteKafalaRequest: 'إرسال طلب إنهاء الإقرار',
                canApproveRejectKafala: 'قبول او رفض الأقرار بكفالة',

                dialog: {
                    ApproveMortgages: { // 1
                        title: 'هل تريد قبول الكفالة؟',
                        body: 'في حال تم قبول الإقرار بكفالة سيتم إعتماد الإقرار وإشعار الأطراف'
                    },
                    ApproveMortgages_Otp: { // 2
                        title: 'تأكيد رمز التحقق',
                        body: 'الرجاء إدخال رمز التحقق المرسل على رقم الجوال المسجل في أبشر',
                        expireTime: 'مدة صلاحية رمز التأكيد',
                        time: ' {0} دقائق و {1} ثانية ',
                        expireTimeEnded: '.. عذراً ، انتهى وقت رمز التحقق'
                    },

                    RejectMortgages: { // 3
                        title: ' هل تريد رفض الكفالة؟',
                        body: 'في حال تم رفض الإقرار بكفالة سيتم إلغاء الطلب وإشعار الأطراف'

                    },
                    sendCompleteKafalaRequest: { // 4
                        title: '  هل تريد انهاء إقرار بكفالة؟',
                        body: ' .عند انهاء إقرار بكفاله سيتم إشعار المكفول له',
                    },
                    rejectCompleteKafalaRequest: { // 5
                        title: ' هل تريد رفض انهاء إقرار بكفالة؟',
                        body: 'عند رفض إنهاء الإقرار بكفالة ستبقى حالة الطلب سارية'
                    },
                    approveCompleteKafalaRequest: { // 6
                        title: ' هل تريد  انهاء إقرار بكفالة؟',
                        body: 'عند الموافقة على إنهاء إقرار بكفالة سيتم إنهاءالإقرار و إشعار الأطراف',

                    },
                    completeKafala: { // 7
                        title: 'هل تريد انهاء إقرار بكفالة؟',
                        body: 'عند الموافقة على إنهاء إقرار بكفالة سيتم إنهاءالإقرار و إشعار الأطراف'
                    },

                }
            },

            buttons: {
                accept: 'أوافق',
                reject: 'أرفض',
                cancel: 'إلغاء',
                confirmation: 'تأكيد',
                add: 'إضافة',
                send: 'ارسال',
                savaAndSend: 'حفظ وإرسال ',
                sendRequest: ' ارسال الطلب'

            },
            create: {},
            other: {
                riyal: 'ريال',
                halalah: 'هللة',
                only: 'فقط لا غير',
                ksa: 'المملكة العربية السعودية',
                ministryOfJustice: 'وزارة العدل',
            },
            viewSak: {
                sakReview: 'معاينة وثيقة الإقــرار',
                sak: 'وثيقة الإقــرار',
                reasonData: 'بيانات السبب',
                print: 'طباعة',
                footer1: 'صدرت هذه الوثيــقة من النظــام الإلكترونــي لخدمـــات التوثـــيق،',
                footer2: 'ويمكن التحقق من صحة الوثيقة عبر الخدمات الإلكترونية لوزارة العدل.',
            }
        },
        iqraratKafala: {
            title: 'اقرارات كفالة',
            iqrar: {
                parties: 'الأطراف',
                party: 'الطرف',
                kafil: 'كفيل',
                makfol: 'مكفول',
                makfolLoh: 'مكفول له',
                iqrarNo: 'رقم الإقرار',
                creationTime: 'تاريخ الإصدار',
                kafalaType: 'نوع الكفالة',
                theType: 'النوع',
                status: 'حالة الإقرار',
                iqrarKafala: 'إقرار بكفالة',
                iqrarType: 'نوع الإقرار',
                resource: 'المصدر',
                kafalaReasonDetails: 'تفاصيل سبب الكفالة',
                kafalaReason: 'سبب الكفالة',
                kafalaPresencePlace: 'جهه التحضير',
                kafalaAmount: 'مبلغ الكفالة',
                kafalaAmountString: 'مبلغ الكفالة نصاً',
                commercialNumber: 'رقم السجل التجاري',
                birthDate: 'تاريخ الميلاد',
                name: 'الأسم',
                nationality: 'الجنسية',
                hawyaType: 'نوع الهوية',
                hawyaNumber: 'رقم الهوية',
                number: 'رقم',
                iqama: 'إقامة',
                hawya: 'الهوية ',
                iqamaOrHawya: 'رقم الهوية / الإقامة',
                partyTarget: 'الصفة',
                validUntil: 'تاريخ انتهاء ',
                invalidInput: 'رقم الهوية / الإقامة غير صحيحة',
                person: 'فرد',
                company: 'شركة',
                hejri: 'هجري',
                melady: 'ميلادي',
                makfoolData: 'بيانات المكفول',
                kafeelData: 'بيانات الكفيل',
                invalidAddKafeel: 'لم يتم اضافة كفيل',
                invalidAddMakfool: 'لم يتم اضافة مكفول',
                addkafeel: 'إضافة كفيل',
                addMakfool: 'إضافة مكفول',
                createIqrarRequest: 'طلب إقرار بكفالة',
                incompleteData: 'البيانات غير مكتملة',
                makfoolaahData: 'بيانات المكفول له',
                kafalaData: 'بيانات الكفالة',
                presence: 'حضورية',
                perform: 'غرمية',
                durationInDays: 'مدة الكفالة',
                sponsorAmount: 'الحق المؤدى من الكفيل',
                sponsoredAmount: 'الحق المؤدى من المكفول',
                sponsoredForAmount: 'الحق المتنازل عنه من المكفول له'
            },
            index: {
                newRequest: 'طلب جديد',
                doneRequestSent: 'تم إرسال الطلب إلى الكفيل',
                requests: 'الطلبات',
                list: 'قائمة الإقرارات',
                SendRequest: 'ارسال الطلب',
                choose: 'اختر',
                filter: 'تصفية النتائج'

            },
            msg: {
                acceptIqrar: 'قبول او رفض الأقرار بكفالة',
                cancelIqrarRequsr: 'إرسال طلب إنهاء الإقرار ',
                cancelIqrarDecision: 'الموافقة او الرفض على طلب إنهاءالإقرار',
                cancelIqrar: 'إنهاء الإقرار',
                dateEntry: 'اختيار التاريخ الزامي',
                unknownError: 'هناك خطأ',
                sorry: 'نعتذر !',
                notCompleteData: 'البيانات غير مكتملة ',
                errorOnRegister: 'خطأ اثناء التسجيل ',
                errorsNationalId: 'رقم الهوية / الإقامة غير صحيحة',
                errorsDateRequire: '  اختيار التاريخ الزامي',
                errorsReasonFieldRequire: 'خانة سبب الكفالة ضرورية',
                errorsFieldRequire: 'خانة "{0}" ضرورية',
                errorsDateFieldRequire: 'خانة "{0}" به التاريخ غير صحيح',

            },
            view: {
                partyDetails: 'بيانات الأطراف',
                iqrarKafalaDetails: 'بيانات إقرار الكفالة',
                completeKafala: 'إنهاء الإقرار',
                canApproveRejectCompleteKafalaRequest: 'الموافقة او الرفض على طلب إنهاءالإقرار',
                canSendCompleteKafalaRequest: 'إرسال طلب إنهاء الإقرار',
                canApproveRejectKafala: 'قبول او رفض الأقرار بكفالة',

                dialog: {
                    ApproveKafala: { // 1
                        title: 'هل تريد قبول الكفالة؟',
                        body: 'في حال تم قبول الإقرار بكفالة سيتم إعتماد الإقرار وإشعار الأطراف'
                    },
                    approveKafala_Otp: { // 2
                        title: 'تأكيد رمز التحقق',
                        body: 'الرجاء إدخال رمز التحقق المرسل على رقم الجوال المسجل في أبشر',
                        expireTime: 'مدة صلاحية رمز التأكيد',
                        time: ' {0} دقائق و {1} ثانية ',
                        expireTimeEnded: '.. عذراً ، انتهى وقت رمز التحقق'
                    },

                    rejectKafala: { // 3
                        title: ' هل تريد رفض الكفالة؟',
                        body: 'في حال تم رفض الإقرار بكفالة سيتم إلغاء الطلب وإشعار الأطراف'

                    },
                    sendCompleteKafalaRequest: { // 4
                        title: '  هل تريد انهاء إقرار بكفالة؟',
                        body: ' .عند انهاء إقرار بكفاله سيتم إشعار المكفول له',
                    },
                    rejectCompleteKafalaRequest: { // 5
                        title: ' هل تريد رفض انهاء إقرار بكفالة؟',
                        body: 'عند رفض إنهاء الإقرار بكفالة ستبقى حالة الطلب سارية'
                    },
                    approveCompleteKafalaRequest: { // 6
                        title: ' هل تريد  انهاء إقرار بكفالة؟',
                        body: 'عند الموافقة على إنهاء إقرار بكفالة سيتم إنهاءالإقرار و إشعار الأطراف',

                    },
                    completeKafala: { // 7
                        title: 'هل تريد انهاء إقرار بكفالة؟',
                        body: 'عند الموافقة على إنهاء إقرار بكفالة سيتم إنهاءالإقرار و إشعار الأطراف'
                    },

                }
            },

            buttons: {
                accept: 'أوافق',
                reject: 'أرفض',
                cancel: 'إلغاء',
                confirmation: 'تأكيد',
                add: 'إضافة',
                send: 'ارسال',
                savaAndSend: 'حفظ وإرسال ',
                sendRequest: ' ارسال الطلب'

            },
            create: {},
            other: {
                riyal: 'ريال',
                halalah: 'هللة',
                only: 'فقط لا غير',
                ksa: 'المملكة العربية السعودية',
                ministryOfJustice: 'وزارة العدل',
            },
            viewSak: {
                sakReview: 'معاينة وثيقة الإقــرار',
                sak: 'وثيقة الإقــرار',
                reasonData: 'بيانات السبب',
                print: 'طباعة',
                footer1: 'صدرت هذه الوثيــقة من النظــام الإلكترونــي لخدمـــات التوثـــيق،',
                footer2: 'ويمكن التحقق من صحة الوثيقة عبر الخدمات الإلكترونية لوزارة العدل.',
            }
        },
        errors: {
            errorTitleNotAllowed: 'غير مسموح',
            notAllowedForCompany: 'عفواً الخدمة غير متاحة في الوقت الحالي',

            sorryErrorTitle: 'نعتذر!',
            generalErrorBody: 'حدث خطأ بالنظام',
            errorInData: 'خطأ في البيانات',
            onlyOneCashAmount: 'لا يمكن اضافة أكثر من مبلغ نقدي',
            maxCashAmount: 'لا يمكن اضافة مبالغ نقدية مجموعها يتعدى 10000 ريال سعودي ',
            fieldRequired: 'خانة "{0}" مطلوب',
            dateFieldRequired: 'التاريخ المدخل للحقل "{0}" غير صحيح',
            reasonFieldRequired: 'خانة سبب الاستحقاق ضرورية',
            sameEntitiesError: 'لا يمكن تحديد نفس الهوية في عدة أطراف',
            ageUnder18Error: 'يجب أن يكون العمر أكبر من أو يساوي 18 عاما',
        }
    }

};

const i18n = new VueI18n({
    locale: 'ar',
    messages,

});

export default i18n;
